import { getEmptyGroupName } from './empty-group-name';

export function transformDefaultValue(value: string): string {
  if (!value) {
    return getEmptyGroupName();
  }

  return value;
}
